import { networkApi } from '../infrastructure/api/NetworkApiClient';
import type { ZoneCoupling, ZoneCouplingEvent, ZoneVerbund } from '../types/coupling';

/**
 * Trennstellen API (backend ZoneCouplingController). Explicit zone ids everywhere — a coupling
 * touches two zones and the calls must not depend on the global zone selection.
 */
export const couplingService = {
  getCouplings(zoneId: string): Promise<ZoneCoupling[]> {
    return networkApi.httpGet<ZoneCoupling[]>(`/zones/${zoneId}/couplings`);
  },

  getVerbund(zoneId: string): Promise<ZoneVerbund> {
    return networkApi.httpGet<ZoneVerbund>(`/zones/${zoneId}/couplings/verbund`);
  },

  getEvents(zoneId: string, couplingId: string): Promise<ZoneCouplingEvent[]> {
    return networkApi.httpGet<ZoneCouplingEvent[]>(`/zones/${zoneId}/couplings/${couplingId}/events`);
  },

  /** Move the switch to another busbar of its KVS (null = busbar 0); changes the union topology. */
  setBusbar(zoneId: string, couplingId: string, busbarId: string | null): Promise<ZoneCoupling> {
    return networkApi.httpPatch<ZoneCoupling>(`/zones/${zoneId}/couplings/${couplingId}/busbar`, { busbarId });
  },

  /** Switch the actual state; journaled by the backend, invalidates the Netzverbund grouping. */
  setState(zoneId: string, couplingId: string, isClosed: boolean, note?: string): Promise<ZoneCoupling> {
    return networkApi.httpPatch<ZoneCoupling>(`/zones/${zoneId}/couplings/${couplingId}/state`, {
      isClosed,
      note: note ?? null,
      source: 'manual',
    });
  },
};
